// Before after slider component
(jQuery)(function ($) {
    $(document).ready(function () {
        const panels = $('.before-after-panel');

        panels.each((index, panel) => {
            const $panel = $(panel);
            const $handle = $panel.find('.before-after-handle');
            const $imageAfter = $panel.find('.image-after');

            const updateFromEvent = (e) => {
                const offset = $panel.offset();
                if (!offset) return;

                const panelWidth = $panel.width();
                const pageX =
                    e.pageX ??
                    (e.originalEvent && e.originalEvent.touches && e.originalEvent.touches[0] && e.originalEvent.touches[0].pageX) ??
                    (e.originalEvent && e.originalEvent.changedTouches && e.originalEvent.changedTouches[0] && e.originalEvent.changedTouches[0].pageX);

                if (pageX == null) return;

                const x = Math.max(0, Math.min(pageX - offset.left, panelWidth));

                // Match existing "inverted width logic"
                $imageAfter.width(panelWidth - x);
                $handle.css('left', x);
            };

            // Desktop hover
            $panel.on('mousemove.beforeAfter', updateFromEvent);
            $panel.on('mouseenter.beforeAfter', updateFromEvent);

            // Mobile: tap/drag handle (and allow dragging on panel too)
            const startDrag = (e) => {
                e.preventDefault();
                updateFromEvent(e);

                $(document)
                    .on('touchmove.beforeAfter pointermove.beforeAfter mousemove.beforeAfter', updateFromEvent)
                    .one('touchend.beforeAfter touchcancel.beforeAfter pointerup.beforeAfter mouseup.beforeAfter', () => {
                        $(document).off('touchmove.beforeAfter pointermove.beforeAfter mousemove.beforeAfter', updateFromEvent);
                    });
            };

            $handle.on('click.beforeAfter', updateFromEvent);
            $handle.on('touchstart.beforeAfter pointerdown.beforeAfter mousedown.beforeAfter', startDrag);

            // Optional: allow dragging anywhere on the panel on mobile
            $panel.on('touchstart.beforeAfter pointerdown.beforeAfter', startDrag);
        });
    });
});
